import Vector2 from "../../math/Vector2";
import SPBullet from "../SPBullet";
import SPGun from "../SPGun";
import SPPlayer from "../SPPlayer";

export default class HeavyBurstCannon extends SPGun {
    constructor(player: SPPlayer) {
        super(player, {
            damage: 5,
            fireRate: 1.5,
            reloadTime: 2,
            bulletSpeed: 100,
            magSize: 4,
            mouseTrigger: 2,
            maxEnemiesHit: 1
        });
    }

    onShoot(): void {
        const startAngle = this.player.transform.rotation.angle - Math.PI/4;

        for (let i = 0; i < 5; i++) {
            const theta = startAngle + Math.PI/2/5 * i;
            const vec = Vector2.fromRadians(theta);

            this.player.engine.NewGameObjectWithScript(SPBullet, {
                position: this.player.transform.position.add(vec.scale(this.player.size + 3)),
                initialValues: {
                    velocity: this.player.velocity.add(vec.scale(this.bulletSpeed)),
                    damage: this.damage,
                    size: 8,
                    isOrb: true
                }
            });
        }
    }
}